import { render, staticRenderFns } from "./Mappings.vue?vue&type=template&id=942bdc4c&scoped=true&"
import script from "./Mappings.vue?vue&type=script&lang=js&"
export * from "./Mappings.vue?vue&type=script&lang=js&"
import style0 from "./Mappings.vue?vue&type=style&index=0&id=942bdc4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942bdc4c",
  null
  
)

export default component.exports